import { createModalStore } from '@/shared/lib/modal';

export const useDebugMenuStore = createModalStore();
